import dynamic from 'next/dynamic';
import React from 'react';

/**
 * Higher Order Component to ensure a component only renders on the client side
 * @param Component The component to render only on the client
 * @returns A component wrapped with dynamic import and ssr: false
 */
export function withClientOnly<P>(Component: React.ComponentType<P>) {
  return dynamic(() => Promise.resolve(Component), {
    ssr: false
  });
}

export default withClientOnly;
